import Products from 'merchandise-lib/constants/Product';
import FreeProducts from 'merchandise-lib/constants/FreeProduct';
import * as UpgradeProducts from 'self-service-api/constants/UpgradeProducts';
import { CMS_ENTERPRISE, CMS_PROFESSIONAL, CMS_STARTER, MARKETING_ENTERPRISE, MARKETING_PLUS_ENTERPRISE, MARKETING_PLUS_PROFESSIONAL, MARKETING_PRO, MARKETING_STARTER_EMAIL, OPERATIONS_ENTERPRISE, OPERATIONS_PROFESSIONAL, OPERATIONS_STARTER, SALES_ENTERPRISE, SALES_PROFESSIONAL, SALES_STARTER, SERVICE_ENTERPRISE, SERVICE_PROFESSIONAL, SERVICE_STARTER } from './UpgradeProducts';

/**
 * @note keep in sync with UpgradeProductToApiNameMap
 */
const ApiNameToUpgradeProductMap = {
  [Products.SALES_HUB_STARTER]: SALES_STARTER,
  [Products.SALES_HUB_PROFESSIONAL]: SALES_PROFESSIONAL,
  [Products.SALES_HUB_ENTERPRISE]: SALES_ENTERPRISE,
  [Products.MARKETING_HUB_STARTER]: MARKETING_STARTER_EMAIL,
  [Products.MARKETING_HUB_PROFESSIONAL]: MARKETING_PRO,
  [Products.MARKETING_HUB_ENTERPRISE]: MARKETING_ENTERPRISE,
  [Products.SERVICE_HUB_STARTER]: SERVICE_STARTER,
  [Products.SERVICE_HUB_PROFESSIONAL]: SERVICE_PROFESSIONAL,
  [Products.SERVICE_HUB_ENTERPRISE]: SERVICE_ENTERPRISE,
  [Products.CMS_HUB_STARTER]: CMS_STARTER,
  [Products.CMS_HUB_PROFESSIONAL]: CMS_PROFESSIONAL,
  [Products.CMS_HUB_ENTERPRISE]: CMS_ENTERPRISE,
  [Products.OPERATIONS_HUB_STARTER]: OPERATIONS_STARTER,
  [Products.OPERATIONS_HUB_PROFESSIONAL]: OPERATIONS_PROFESSIONAL,
  [Products.OPERATIONS_HUB_ENTERPRISE]: OPERATIONS_ENTERPRISE,
  [Products.MARKETING_PLUS_SUITE_BUNDLE_PROFESSIONAL]: MARKETING_PLUS_PROFESSIONAL,
  [Products.MARKETING_PLUS_SUITE_BUNDLE_ENTERPRISE]: MARKETING_PLUS_ENTERPRISE,
  [Products.CORE_SEATS_STARTER]: UpgradeProducts.CORE_SEATS_STARTER,
  [Products.CORE_SEATS_PROFESSIONAL]: UpgradeProducts.CORE_SEATS_PROFESSIONAL,
  [Products.CORE_SEATS_ENTERPRISE]: UpgradeProducts.CORE_SEATS_ENTERPRISE,
  [Products.ADS_LIMIT_INCREASE]: UpgradeProducts.ADS,
  [Products.REPORTING_LIMIT_INCREASE]: UpgradeProducts.REPORTING,
  [Products.TECH_SERVICE_DEDICATED_IP_FOR_EMAIL]: UpgradeProducts.DEDICATED_IP,
  [Products.TRANSACTIONAL_EMAIL]: UpgradeProducts.TRANSACTIONAL_EMAIL,
  [Products.BRAND_DOMAIN]: UpgradeProducts.BRAND_DOMAIN,
  [Products.WORKFLOWS_LIMIT_INCREASE]: UpgradeProducts.WORKFLOWS_ADDON,
  [Products.LISTS_LIMIT_INCREASE]: UpgradeProducts.LISTS_ADDON,
  [FreeProducts.HUBSPOT_FREE]: UpgradeProducts.CRM,
  [Products.TECHNICAL_CONSULTING_ONGOING]: UpgradeProducts.DESIGNATED_TECHNICAL_SUPPORT,
  [Products.STARTER_KIT]: UpgradeProducts.STARTER_KIT,
  [Products.SALES_HUB_PROFESSIONAL_ONBOARDING]: UpgradeProducts.SALES_PROFESSIONAL_ONBOARDING,
  [Products.SERVICE_HUB_PROFESSIONAL_ONBOARDING]: UpgradeProducts.SERVICE_PROFESSIONAL_ONBOARDING,
  [Products.WEB_HOSTING_CUSTOM_SSL_PACK]: UpgradeProducts.CUSTOM_SSL,
  [Products.MARKETING_SMS]: UpgradeProducts.MARKETING_SMS_ADDON,
  [Products.MARKETING_SMS_SHORT_CODE]: UpgradeProducts.MARKETING_SMS_SHORT_CODE,
  [Products.CRM_SUITE_STARTER_BUNDLE]: UpgradeProducts.SUITE_STARTER,
  [Products.CRM_SUITE_PROFESSIONAL_BUNDLE]: UpgradeProducts.SUITE_PROFESSIONAL,
  [Products.CRM_SUITE_ENTERPRISE_BUNDLE]: UpgradeProducts.SUITE_ENTERPRISE,
  [Products.DOMAINS_LIMIT_INCREASE]: UpgradeProducts.DOMAINS_LIMIT_INCREASE,
  [Products.SANDBOX_LIMIT_INCREASE]: UpgradeProducts.SANDBOX_LIMIT_INCREASE,
  [Products.ESIGNATURE_LIMIT_INCREASE]: UpgradeProducts.ESIGNATURE_LIMIT_INCREASE,
  [Products.CALLING_LIMIT_INCREASE]: UpgradeProducts.CALLING_LIMIT_INCREASE,
  [Products.PHONE_LIMIT_INCREASE]: UpgradeProducts.PHONE_LIMIT_INCREASE,
  [Products.TEAMS_LIMIT_INCREASE]: UpgradeProducts.TEAMS_LIMIT_INCREASE,
  [Products.WHATSAPP_LIMIT_INCREASE]: UpgradeProducts.WHATSAPP_LIMIT_INCREASE,
  [Products.VIDEO_LIMIT_INCREASE]: UpgradeProducts.VIDEO_LIMIT_INCREASE,
  [Products.CUSTOM_OBJECTS_LIMIT_INCREASE]: UpgradeProducts.CUSTOM_OBJECTS_LIMIT_INCREASE,
  [Products.CALCULATED_PROPERTIES_LIMIT_INCREASE]: UpgradeProducts.CALCULATED_PROPERTIES_LIMIT_INCREASE,
  [Products.CUSTOM_PROPERTIES_LIMIT_INCREASE]: UpgradeProducts.CUSTOM_PROPERTIES_LIMIT_INCREASE,
  [Products.CRM_OBJECT_LIMIT_INCREASE]: UpgradeProducts.CRM_OBJECT_LIMIT_INCREASE,
  [Products.NON_MARKETING_CONTACTS_LIMIT_INCREASE]: UpgradeProducts.CRM_CONTACT_RECORDS_LIMIT_INCREASE,
  [Products.BREEZE_INTELLIGENCE_CREDITS_100]: UpgradeProducts.BREEZE_INTELLIGENCE_CREDITS_100,
  [Products.BREEZE_INTELLIGENCE_CREDITS_1000]: UpgradeProducts.BREEZE_INTELLIGENCE_CREDITS_1000,
  [Products.BREEZE_INTELLIGENCE_CREDITS_10000]: UpgradeProducts.BREEZE_INTELLIGENCE_CREDITS_10000,
  [Products.BREEZE_INTELLIGENCE_CREDITS_100_COMMITTED]: UpgradeProducts.BREEZE_INTELLIGENCE_CREDITS_100_COMMITTED,
  [Products.BREEZE_INTELLIGENCE_CREDITS_1000_COMMITTED]: UpgradeProducts.BREEZE_INTELLIGENCE_CREDITS_1000_COMMITTED,
  [Products.BREEZE_INTELLIGENCE_CREDITS_10000_COMMITTED]: UpgradeProducts.BREEZE_INTELLIGENCE_CREDITS_10000_COMMITTED,
  [Products.BREEZE_INTELLIGENCE_OVERAGE_CREDITS_FOR_100]: UpgradeProducts.BREEZE_INTELLIGENCE_OVERAGE_CREDITS_FOR_100,
  [Products.BREEZE_INTELLIGENCE_OVERAGE_CREDITS_FOR_1000]: UpgradeProducts.BREEZE_INTELLIGENCE_OVERAGE_CREDITS_FOR_1000,
  [Products.BREEZE_INTELLIGENCE_OVERAGE_CREDITS_FOR_10000]: UpgradeProducts.BREEZE_INTELLIGENCE_OVERAGE_CREDITS_FOR_10000,
  [Products.HUBSPOT_CREDITS_COMMITTED]: UpgradeProducts.HUBSPOT_CREDITS_COMMITTED,
  [Products.HUBSPOT_CREDITS_COMMITTED_OVERAGE]: UpgradeProducts.HUBSPOT_CREDITS_COMMITTED_OVERAGE,
  [Products.HUBSPOT_CREDITS_OVERAGE]: UpgradeProducts.HUBSPOT_CREDITS_OVERAGE,
  [Products.COMMERCE_HUB_PROFESSIONAL]: UpgradeProducts.COMMERCE_PROFESSIONAL,
  [Products.COMMERCE_HUB_ENTERPRISE]: UpgradeProducts.COMMERCE_ENTERPRISE
};
export default ApiNameToUpgradeProductMap;